module.exports = __webpack_public_path__ + "img/featurefour1.1126820c.png";